import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';


export class FirebaseNotificationTaskProgressReport extends BaseDto {
    code: string;
    status: string;
    totalAccounts: number;
    totalDevices: number;
    successfulSends: number;
    failedSends: number;
    errorMessage: string;
    progress: number;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor() {
        super();
    }
}
